var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnlockGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10C6.9 10 6 10.9 6 12V18C6 19.1 6.9 20 8 20H16C17.1 20 18 19.1 18 18V12C18 10.9 17.1 10 16 10H8ZM16 18V12H8V18H16Z",
    fill: "#19252E",
    fillOpacity: 0.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 5.8 13.8 4 16 4V5.8C14.9 5.8 14 6.7 14 7.8V10H12V8Z",
    fill: "#19252E",
    fillOpacity: 0.72
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20 5.8 18.2 4 16 4V5.8C17.1 5.8 18 6.7 18 7.8V10H20V8Z",
    fill: "#19252E",
    fillOpacity: 0.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H13V17H11V13Z",
    fill: "#19252E",
    fillOpacity: 0.72
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlockGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlockGrey.2fa27570ac6eb086d61ba1ea4cf697fe.svg";